<template>
  <OwnCard
    class="own-toggle"
    :background-color="control ? 'primary' : 'transparent'"
    :control="control"
    :disabled="disabled"
    el="button"
    @keyup.enter="toggleActive"
    @click.stop="toggleActive"
  >
    <span
      :class="[
        'flex-row gap-2 align-center justify-between w-full',
        control && 'own-toggle__trigger-control',
        disabled && 'own-toggle__trigger-control--disabled',
      ]"
    >
      <span class="flex-row gap-2 justify-start align-start">
        <slot name="prepend" />
        <span v-if="label || description" class="flex-col gap-1">
          <OwnType
            v-if="label"
            :text="label"
            :class="[
              'own-toggle__text',
              disabled && 'own-toggle__text--disabled',
            ]"
            el="label"
            variant="title-regular"
            color="primary"
          />
          <OwnType
            v-if="description"
            :text="description"
            :class="[
              'own-toggle__text',
              disabled && 'own-toggle__text--disabled',
            ]"
            el="span"
            variant="paragraph-small"
          />
        </span>
      </span>

      <ToggleSwitch
        :disabled="disabled"
        class="flex-shrink-0"
        :active="inputValue"
      />
    </span>
  </OwnCard>
</template>

<script lang="ts" setup>
import { OwnCard } from '../OwnCard'
import { OwnType } from '../OwnType'

import ToggleSwitch from './components/ToggleSwitch.vue'

const props = withDefaults(
  defineProps<{
    control?: boolean
    description?: string
    disabled?: boolean
    label?: string
  }>(),
  {
    control: false,
    description: undefined,
    disabled: false,
    label: undefined,
  }
)

const inputValue = defineModel<boolean>({ default: false })

const toggleActive = () => {
  if (props.disabled) {
    return
  }

  inputValue.value = !inputValue.value
}
</script>

<style lang="scss">
.own-toggle {
  width: 100%;

  &__text {
    cursor: pointer;
    &--disabled {
      cursor: default;
    }
  }

  &__trigger-control {
    padding: 12px 16px;

    &--disabled {
      cursor: default;
    }
  }
}
</style>
